import functions from "./functions.js";
//import tplLoader from "./tpl-loader.js";

$(function () {

    const $form = $('.booking-form');
    const form = $form[0];

    if (!form) {
        return;
    }

    const booking = {
        $form: null,
        totalAmount: null,
        promoCodeAmount: null,
        promoCodeAmountIn: null,
        $payment: null,
        $calculation: null,
        subscribed: false,
        urlParams: null,
        calc: [],
        persons: null,
        numberOfPets: 0,

        init() {
            booking.$form = $(".booking-form");
            booking.$calculation = $(".table-calculation");
            booking.$payment = $(".payment-details");
            booking.params = {};

            // BOOKING PAYMENT TYPE CHECKBOX
            if($('[name="paymentType"]')[0]) {
                checkPaymentType();
                $('[name="paymentType"]').on('change', e => {
                    checkPaymentType();
                });

                function checkPaymentType() {
                    $('[name="paymentType"]').each((index, item) => {
                        const $item = $(item);
                        const id = $item.attr('id');
                        $('[for=' + id + ']').find('[id='  + id + ']').prop('checked', $item.is(':checked'));
                    });
                }
            }

            $("*[data-calc]").each(function (index) {
                let item = JSON.parse($(this).attr('data-calc'));
                item.inCalc = item.isOptional ? 0 : 1;
                booking.calc.push(item);
            });

            $('.calc-item').find('input[type="checkbox"]').change(function (e) {
                let $calcItem = $(this).closest('.calc-item');
                let $quantity = $calcItem.find('select.quantity');
                let value = +$quantity.val();
                let checked = $(this).is(':checked') ? 1 : 0;

                if (checked && !value) {
                    $quantity.prop('value', 1);
                } else if (!checked && value) {
                    $quantity.prop('value', 0);
                }

                booking.calculate($(this));
            });

            $('.calc-item').find('select.quantity').change(function (e) {
                let $calcItem = $(this).closest('.calc-item');
                let $checkbox = $calcItem.find('input[type="checkbox"]');
                let value = +$(this).val();

                if (value && !$checkbox.is(':checked')) {
                    $checkbox.prop('checked', true);
                } else if (!value && $checkbox.is(':checked')) {
                    $checkbox.prop('checked', false);
                }

                booking.calculate($(this));
            });

            booking.total();

            if (booking.$payment.length) {
                booking.params.paymentType = 'bankTransfer';
                booking.$payment.find('input[name="paymentType"]').change(function (e) {
                    booking.params.paymentType = booking.$payment.find('input[name="paymentType"]:checked').val();
                });
            }

            $('.payment-type-wrapper').on('click', function (e) {
                let labelTag = $(e.target).closest('label').attr('for');
                let $labels = $(this).find('label');
                $labels.each((index, item) => {
                    let $elem = $(item);
                    if ($elem.attr('for') == labelTag)
                    {
                        $elem.removeClass('border-white').addClass('border-primary');
                    }
                    else
                    {
                        $elem.removeClass('border-primary').addClass('border-white');
                    }
                    let $transferInfo = $elem.find('.bank-transfer-info');
                    if($transferInfo.length) $transferInfo.toggleClass('active', $elem.attr('for') == labelTag)
                })
            });


            booking.$form.on('submit', e => {
                //e.preventDefault();
                //e.stopPropagation();

                /*let $paymentTypeForm = $('.payment-details');
                if ( ! $paymentTypeForm[0].checkValidity()) {
                    
                    var tmpSubmit = document.createElement('button');
                    $paymentTypeForm[0].appendChild(tmpSubmit);
                    tmpSubmit.click();
                    $paymentTypeForm[0].removeChild(tmpSubmit);

                    e.preventDefault();
                    return;
                }*/

                $('.booking-btn').attr('disabled', 'disabled');
                booking.submit(e);
            });

            
            $(".btn-promo-code").on('click', e => {
                $(".btn-promo-code").attr('disabled', true);
                let params = functions.getUrlData(false);
                let formData = functions.getFormData(booking.$form);

                params['partnerId'] = formData.partnerId;
                params['language'] = functions.getLang();
                params['promoCode'] = $("input[name='promoCode']").val();

                $.post('/services/promoCode/', params).then(response => {

                    response = JSON.parse(response);

                    if (response.status == true) {

                        $('.promo-code-error').addClass('d-none');
                        $('.promo-code-success').removeClass('d-none');

                        booking.promoCodeData = response;
                        booking.promoCodeData.promoCode = params['promoCode'];

                        booking.applyPromoCodeDiscount(booking.promoCodeData);

                        let calcItem = {
                            promoCode: true,
                            id: functions.uniqid(),
                            quantity: 1,
                            guests: params.guests,
                            unitId: params.unitId,
                            dateFrom: params.dateFrom,
                            dateTo: params.dateTo,
                            price: -1 * booking.promoCodeAmount,
                            priceIn: -1 * booking.promoCodeAmountIn,
                            total: -1 * booking.promoCodeAmount,
                            totalIn: -1 * booking.promoCodeAmountIn,
                            itemTitle: {
                                name_hr: booking.promoCodeData.promoCode,
                                name_en: booking.promoCodeData.promoCode,
                                name_de: booking.promoCodeData.promoCode,
                            },
                            itemDefinitionId: {
                                id: 15,
                                text: "Popust na period",
                                categoryId: {
                                    id: 4,
                                    text: "Popust na termin",
                                    key: "forPeriod"
                                },
                                objectGroupId: {
                                    id: 1,
                                    text: "accommodation",
                                    key: "accommodation"
                                },
                                typeId: {
                                    id: 3,
                                    text: "Popust",
                                    key: "discount"
                                }
                            },
                            paymentTypeId: {
                                id: 4,
                                text: "po jedinici",
                                key: "Once"
                            },
                            onSpot: 0,
                            isOptional: 0,
                            pricelistId: null,
                            priceConverted: 0,
                            viewOrder: 1,
                            inCalc: 1,
                            skipCalculate: true,
                            promoCodeId: booking.promoCodeData.promoCodeId,
                        };

                        let calcItemHTML = `<div class="calc-item promo-code-calc-item">
                            <div class="row"
                                data-calc="${ JSON.stringify(calcItem) }">
                                <div class="col-auto">
                                    <label for="${ calcItem.id }" class="small">Promo code</label>
                                </div>
                                <div class="col-auto col-lg text-end">
                                    € <span class="price small">${ functions.formatMoney(calcItem.total, 2, ',', '.') }</span>
                                </div>
                            </div>
                        </div>`;

                        const $promoCodeCalcItem = $('.table-calculation .calc-item.promo-code-calc-item');

                        if ($promoCodeCalcItem.length) {
                            $promoCodeCalcItem.replaceWith(calcItemHTML);
                        } else {
                            $('.table-calculation').append(calcItemHTML);
                        }

                        booking.printTotalAmount(booking.totalAmount);

                        booking.calc = booking.calc.filter(item => ! item.promoCode);
                        booking.calc.push(calcItem);
                    } else {
                        $('.promo-code-error').removeClass('d-none');
                        $('.promo-code-success').addClass('d-none');
                    }

                });

                $.post('/services/booking_form/', params).then(response => {

                    if (response.status) {
                        $('.card-footer').html(response.response);
                        booking.printTotalAmount(booking.totalAmount);
                    }

                    $(".btn-promo-code").attr('disabled', false);
                });


            });

            let params = functions.getUrlData(false);
            if (params.numberOfPets == 'undefined') params.numberOfPets = 0;

            params.numberOfPets && $('#quantity-pets').val(params.numberOfPets).change();
            
            functions.setFormData(booking.$form[0], params)

        },
        applyPromoCodeDiscount (promoCode) {
            let totalAmount = booking.getTotalAmountOrigin();
            let totalInAmount = booking.getTotalInAmountOrigin();

            let discountAmount = 0;
            let discountInAmount = 0;

            if (promoCode.percent) {
                let percent = +promoCode.percent;

                discountAmount = totalAmount * (percent / 100);
                discountInAmount = totalInAmount * (percent / 100);

                totalAmount -= discountAmount;
                totalInAmount -= discountInAmount;

            } else if (promoCode.amount) {

                discountAmount = totalAmount - promoCode.amount;
                discountInAmount = totalInAmount - promoCode.amount;

            }

            booking.printTotalAmount(totalAmount);
            booking.setTotalAmount(totalAmount);

            booking.promoCodeAmount = discountAmount;
            booking.promoCodeAmountIn = discountInAmount;

        },
        async submit(e) {
            
            if ($('[name="newsletter"]').length && $('[name="newsletter"]').is(":checked") && ! this.subscribed)
            {
                e.preventDefault();
                let email = $('[name="email"]').val();
                const results = await $.post('/services/mailchimp/', {email: email, language: functions.getLang()});
                if (! results.status)
                {
                    $('.booking-btn').attr('disabled', false);
                    $('.response-status').removeClass('d-none').html(results.data);
                    setTimeout(() => {
                        $('.response-status').addClass('d-none').html('');
                    }, 10000);

                    return;
                }
                else
                {
                    this.subscribed = true;
                    booking.$form.submit();
                }

                
            }

            let petsTtitle = {
                hr: 'Kućni ljubimci: ',
                en: 'Pets: ',
                de: 'Haustiere: ',
            }

            let formParams = functions.getFormData(booking.$form);
            if (formParams.numberOfPets == 'undefined') formParams.numberOfPets = 0;

            $.each(booking.calc, function(key, item) {
                if ( ! item.inCalc) {
                    delete booking.calc[key];
                } else if (item.itemDefinitionId.categoryId.key == 'baseRate') {
                    let $guestsPerProduct = $("[data-guests-parentId='" + item.parentId + "']");
                    let guests = [];

                    if ($guestsPerProduct.length) {
                        $guestsPerProduct.find('[data-guests]').each(function (index) {
                            let g = +$(this).data('guests');
                            guests[index] = {
                                firstName : $(this).find("input[name='firstName" + g + "']").val(),
                                lastName : $(this).find("input[name='lastName" + g + "']").val(),
                                age : $(this).find("input[name='age" + g + "']").val()
                            };
                        });
                        booking.calc[key].guestsData = guests;
                    }

                    if (formParams.numberOfPets) 
                    {
                        booking.calc[key].notePublic = (petsTtitle[functions.getLang()] || 'Pets: ') + formParams.numberOfPets;
                        booking.calc[key].noteSupplier = (petsTtitle[($('.booking-pricing-container').attr('data-language') || 'hr')]) + formParams.numberOfPets;
                    }
                }
            });

            booking.params.calc = JSON.stringify(booking.calc);
            booking.params.requestId = Math.floor(Math.random() * ((9999999 - 1000000) + 1) + 1000000);

            $.each(booking.params, function (key, param) {
                $('<input>').attr({
                    type: 'hidden',
                    name: key,
                    value: param
                }).appendTo(booking.$form);
            });

        },
        calculate($elem) {
            let $calcItem = $elem.closest('.calc-item');

            let $checkbox = $calcItem.find('input[type="checkbox"]');
            let checked = $checkbox.is(':checked') ? 1 : 0;
            let id = $checkbox.attr('id');

            let $quantity = $calcItem.find('select.quantity');
            let quantity = null;

            if ($quantity.length) {
                quantity = +$quantity.val();
            }


            $.each(booking.calc, function (key, calc) {
                if (calc && calc.id == id) {

                    if (quantity == null) {
                        quantity = booking.calc[key].quantity;
                    }

                    booking.calc[key].inCalc = checked;
                    booking.calc[key].quantity = (quantity || 1);
                    booking.calc[key].total = booking.itemTotal(booking.calc[key]);

                    $calcItem.find('.item-total-amount').html(functions.formatMoney(booking.calc[key].total, 2, ',', '.'));
                }
            });

            booking.total();
        },
        itemTotal(item) {
            let itemTotal = 0.00;

            if (item.paymentTypeId.key) {

                if ($.inArray(item.paymentTypeId.key, ['perPerson', 'perPersonPerDay', 'perPersonPerWeek']) > -1) {
                    itemTotal = +item.quantity * +item.price;
                } else {
                    itemTotal = +item.price;
                }
            } else {
                itemTotal = +item.quantity * +item.price;
            }

            return itemTotal;
        },
        itemInTotal(item) {
            let itemInTotal = 0.00;

            if (item.paymentTypeId.key) {

                if ($.inArray(item.paymentTypeId.key, ['perPerson', 'perPersonPerDay', 'perPersonPerWeek']) > -1) {
                    itemInTotal = +item.quantity * +item.priceIn;
                } else {
                    itemInTotal = +item.priceIn;
                }
            } else {
                itemInTotal = +item.quantity * +item.priceIn;
            }

            return itemInTotal;
        },
        getTotalAmount () {
            let totalAmount = 0;

            $.each(booking.calc, function (key, calc) {
                if (!calc.onSpot && calc.inCalc) {
                    totalAmount += booking.itemTotal(calc);
                }
            });

            return totalAmount;
        },
        getTotalAmountOrigin () {
            let totalAmount = 0;

            $.each(booking.calc, function (key, calc) {
                if (! calc.promoCode && ! calc.onSpot && calc.inCalc) {
                    totalAmount += booking.itemTotal(calc);
                }
            });

            return totalAmount;
        },
        getTotalInAmountOrigin () {
            let totalInAmount = 0;

            $.each(booking.calc, function (key, calc) {
                if (! calc.promoCode && ! calc.onSpot && calc.inCalc) {
                    totalInAmount += booking.itemInTotal(calc);
                }
            });

            return totalInAmount;
        },
        setTotalAmount (totalAmount) {
            booking.totalAmount = totalAmount;
        },
        printTotalAmount (totalAmount) {
            const $paymentDetails = $('.payment-details');

            const advancePaymentPercent = $paymentDetails.attr('data-advancepaymentpercent');
            const commissionForCreditCard = +$paymentDetails.attr('data-commissionforcreditcard');

            let totalAmountCard = totalAmount + ((totalAmount * commissionForCreditCard ) / 100);

            let advanceCard = totalAmountCard * (advancePaymentPercent / 100);
            let restCard = totalAmountCard - advanceCard;

            let advance = totalAmount * (advancePaymentPercent / 100);
            let rest = totalAmount - advance;

            $('.total-amount').html('€ ' + functions.formatMoney(totalAmount, 2, ',', '.'));

            $('.payment-type[for="creditCard"]').find('.advance').html(functions.formatMoney(advanceCard, 2, ',', '.'));
            $('.payment-type[for="creditCard"]').find('.rest').html(functions.formatMoney(restCard, 2, ',', '.'));

            $('.card-footer').find('.advance').html(functions.formatMoney(advance, 2, ',', '.'));
            $('.card-footer').find('.rest').html(functions.formatMoney(rest, 2, ',', '.'));
        },
        total () {
            let totalAmount = booking.getTotalAmount();
            booking.printTotalAmount(totalAmount);
            booking.setTotalAmount(totalAmount);
        }
    }

    booking.init();
});